/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root"
import { Route as Char126offlineRouteImport } from "./routes/~offline"
import { Route as SyncStatusRouteImport } from "./routes/sync-status"
import { Route as PrintTestRouteImport } from "./routes/print-test"
import { Route as NoAccessRouteImport } from "./routes/no-access"
import { Route as InstallRouteImport } from "./routes/install"
import { Route as AcceptInvitationRouteImport } from "./routes/accept-invitation"
import { Route as AuthenticatedRouteImport } from "./routes/_authenticated"
import { Route as AuthRouteImport } from "./routes/_auth"
import { Route as IndexRouteImport } from "./routes/index"
import { Route as AuthenticatedSetPasswordRouteImport } from "./routes/_authenticated/set-password"
import { Route as AuthenticatedRoomsRouteImport } from "./routes/_authenticated/rooms"
import { Route as AuthenticatedNurseriesRouteImport } from "./routes/_authenticated/nurseries"
import { Route as AuthenticatedGlobalTemplatesRouteImport } from "./routes/_authenticated/global-templates"
import { Route as AuthenticatedDashboardRouteImport } from "./routes/_authenticated/dashboard"
import { Route as AuthVerifyEmailRouteImport } from "./routes/_auth/verify-email"
import { Route as AuthResetPasswordRouteImport } from "./routes/_auth/reset-password"
import { Route as AuthRegisterRouteImport } from "./routes/_auth/register"
import { Route as AuthLoginRouteImport } from "./routes/_auth/login"
import { Route as AuthForgotPasswordRouteImport } from "./routes/_auth/forgot-password"
import { Route as AuthenticatedTemplatesIndexRouteImport } from "./routes/_authenticated/templates/index"
import { Route as AuthenticatedTaskManagerIndexRouteImport } from "./routes/_authenticated/task-manager/index"
import { Route as AuthenticatedSettingsIndexRouteImport } from "./routes/_authenticated/settings/index"
import { Route as AuthenticatedPlatformSettingsIndexRouteImport } from "./routes/_authenticated/platform-settings/index"
import { Route as AuthenticatedPeopleIndexRouteImport } from "./routes/_authenticated/people/index"
import { Route as AuthenticatedOrganisationsIndexRouteImport } from "./routes/_authenticated/organisations/index"
import { Route as AuthenticatedMonitoringIndexRouteImport } from "./routes/_authenticated/monitoring/index"
import { Route as AuthenticatedLogsIndexRouteImport } from "./routes/_authenticated/logs/index"
import { Route as AuthenticatedFollowUpActionsIndexRouteImport } from "./routes/_authenticated/follow-up-actions/index"
import { Route as AuthenticatedFireExtinguisherChecksIndexRouteImport } from "./routes/_authenticated/fire-extinguisher-checks/index"
import { Route as AuthenticatedEvidenceHubIndexRouteImport } from "./routes/_authenticated/evidence-hub/index"
import { Route as AuthenticatedEventRecordsIndexRouteImport } from "./routes/_authenticated/event-records/index"
import { Route as AuthenticatedEmergencyLightChecksIndexRouteImport } from "./routes/_authenticated/emergency-light-checks/index"
import { Route as AuthenticatedComplianceIndexRouteImport } from "./routes/_authenticated/compliance/index"
import { Route as AuthenticatedComplianceManagerIndexRouteImport } from "./routes/_authenticated/compliance-manager/index"
import { Route as AuthenticatedChecklistsIndexRouteImport } from "./routes/_authenticated/checklists/index"
import { Route as AuthenticatedChecklistManagerIndexRouteImport } from "./routes/_authenticated/checklist-manager/index"
import { Route as PrintIncidentsIncidentIdRouteImport } from "./routes/print/incidents.$incidentId"
import { Route as PrintEventRecordsEventRecordIdRouteImport } from "./routes/print/event-records.$eventRecordId"
import { Route as AuthenticatedPlatformSettingsStreakRulesRouteImport } from "./routes/_authenticated/platform-settings/streak-rules"
import { Route as AuthenticatedPlatformSettingsCategoriesRouteImport } from "./routes/_authenticated/platform-settings/categories"
import { Route as AuthenticatedPeopleNewRouteImport } from "./routes/_authenticated/people/new"
import { Route as AuthenticatedOrganisationsSlugRouteImport } from "./routes/_authenticated/organisations/$slug"
import { Route as AuthenticatedLogsLogTypeIdRouteImport } from "./routes/_authenticated/logs/$logTypeId"
import { Route as AuthenticatedIncidentsIncidentIdRouteImport } from "./routes/_authenticated/incidents/$incidentId"
import { Route as AuthenticatedHotHoldingAlertsAlertIdRouteImport } from "./routes/_authenticated/hot-holding-alerts/$alertId"
import { Route as AuthenticatedFollowUpActionsCreateRouteImport } from "./routes/_authenticated/follow-up-actions/create"
import { Route as AuthenticatedFollowUpActionsActionIdRouteImport } from "./routes/_authenticated/follow-up-actions/$actionId"
import { Route as AuthenticatedFireExtinguisherChecksNewRouteImport } from "./routes/_authenticated/fire-extinguisher-checks/new"
import { Route as AuthenticatedFireExtinguisherChecksCheckIdRouteImport } from "./routes/_authenticated/fire-extinguisher-checks/$checkId"
import { Route as AuthenticatedEventRecordsNewRouteImport } from "./routes/_authenticated/event-records/new"
import { Route as AuthenticatedEventRecordsEventRecordIdRouteImport } from "./routes/_authenticated/event-records/$eventRecordId"
import { Route as AuthenticatedEmergencyLightChecksNewRouteImport } from "./routes/_authenticated/emergency-light-checks/new"
import { Route as AuthenticatedEmergencyLightChecksCheckIdRouteImport } from "./routes/_authenticated/emergency-light-checks/$checkId"
import { Route as AuthenticatedComplianceNewRouteImport } from "./routes/_authenticated/compliance/new"
import { Route as AuthenticatedChecklistsIdRouteImport } from "./routes/_authenticated/checklists/$id"
import { Route as AuthenticatedAcknowledgementsRequestIdRouteImport } from "./routes/_authenticated/acknowledgements/$requestId"
import { Route as AuthenticatedSettingsStaffIndexRouteImport } from "./routes/_authenticated/settings/staff/index"
import { Route as AuthenticatedPeopleUserIdIndexRouteImport } from "./routes/_authenticated/people/$userId/index"
import { Route as AuthenticatedOrganisationsSlugIndexRouteImport } from "./routes/_authenticated/organisations/$slug/index"
import { Route as AuthenticatedTemplatesTemplateIdScheduleRouteImport } from "./routes/_authenticated/templates/$templateId/schedule"
import { Route as AuthenticatedSettingsStaffNewRouteImport } from "./routes/_authenticated/settings/staff/new"
import { Route as AuthenticatedPeopleUserIdLoginHistoryRouteImport } from "./routes/_authenticated/people/$userId/login-history"
import { Route as AuthenticatedOrganisationsSlugTemplatesRouteImport } from "./routes/_authenticated/organisations/$slug/templates"
import { Route as AuthenticatedOrganisationsSlugMembersRouteImport } from "./routes/_authenticated/organisations/$slug/members"
import { Route as AuthenticatedOrganisationsSlugConfigureRouteImport } from "./routes/_authenticated/organisations/$slug/configure"
import { Route as AuthenticatedComplianceInstanceInstanceIdRouteImport } from "./routes/_authenticated/compliance/instance/$instanceId"
import { Route as AuthenticatedComplianceDefinitionDefinitionIdRouteImport } from "./routes/_authenticated/compliance/definition/$definitionId"
import { Route as AuthenticatedComplianceDefinitionIdEditRouteImport } from "./routes/_authenticated/compliance/$definitionId/edit"
import { Route as AuthenticatedOrganisationsSlugBranchesIndexRouteImport } from "./routes/_authenticated/organisations/$slug/branches/index"
import { Route as AuthenticatedSettingsStaffIdLoginAttemptsRouteImport } from "./routes/_authenticated/settings/staff/$id/login-attempts"
import { Route as AuthenticatedSettingsStaffIdEditRouteImport } from "./routes/_authenticated/settings/staff/$id/edit"
import { Route as AuthenticatedOrganisationsSlugBranchesBranchIdRouteImport } from "./routes/_authenticated/organisations/$slug/branches/$branchId"

const Char126offlineRoute = Char126offlineRouteImport.update({
  id: "/~offline",
  path: "/~offline",
  getParentRoute: () => rootRouteImport,
} as any)
const SyncStatusRoute = SyncStatusRouteImport.update({
  id: "/sync-status",
  path: "/sync-status",
  getParentRoute: () => rootRouteImport,
} as any)
const PrintTestRoute = PrintTestRouteImport.update({
  id: "/print-test",
  path: "/print-test",
  getParentRoute: () => rootRouteImport,
} as any)
const NoAccessRoute = NoAccessRouteImport.update({
  id: "/no-access",
  path: "/no-access",
  getParentRoute: () => rootRouteImport,
} as any)
const InstallRoute = InstallRouteImport.update({
  id: "/install",
  path: "/install",
  getParentRoute: () => rootRouteImport,
} as any)
const AcceptInvitationRoute = AcceptInvitationRouteImport.update({
  id: "/accept-invitation",
  path: "/accept-invitation",
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: "/_authenticated",
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: "/_auth",
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedSetPasswordRoute =
  AuthenticatedSetPasswordRouteImport.update({
    id: "/set-password",
    path: "/set-password",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedRoomsRoute = AuthenticatedRoomsRouteImport.update({
  id: "/rooms",
  path: "/rooms",
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedNurseriesRoute = AuthenticatedNurseriesRouteImport.update({
  id: "/nurseries",
  path: "/nurseries",
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedGlobalTemplatesRoute =
  AuthenticatedGlobalTemplatesRouteImport.update({
    id: "/global-templates",
    path: "/global-templates",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedDashboardRoute = AuthenticatedDashboardRouteImport.update({
  id: "/dashboard",
  path: "/dashboard",
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthVerifyEmailRoute = AuthVerifyEmailRouteImport.update({
  id: "/verify-email",
  path: "/verify-email",
  getParentRoute: () => AuthRoute,
} as any)
const AuthResetPasswordRoute = AuthResetPasswordRouteImport.update({
  id: "/reset-password",
  path: "/reset-password",
  getParentRoute: () => AuthRoute,
} as any)
const AuthRegisterRoute = AuthRegisterRouteImport.update({
  id: "/register",
  path: "/register",
  getParentRoute: () => AuthRoute,
} as any)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: "/login",
  path: "/login",
  getParentRoute: () => AuthRoute,
} as any)
const AuthForgotPasswordRoute = AuthForgotPasswordRouteImport.update({
  id: "/forgot-password",
  path: "/forgot-password",
  getParentRoute: () => AuthRoute,
} as any)
const AuthenticatedTemplatesIndexRoute =
  AuthenticatedTemplatesIndexRouteImport.update({
    id: "/templates/",
    path: "/templates/",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedTaskManagerIndexRoute =
  AuthenticatedTaskManagerIndexRouteImport.update({
    id: "/task-manager/",
    path: "/task-manager/",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSettingsIndexRoute =
  AuthenticatedSettingsIndexRouteImport.update({
    id: "/settings/",
    path: "/settings/",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPlatformSettingsIndexRoute =
  AuthenticatedPlatformSettingsIndexRouteImport.update({
    id: "/platform-settings/",
    path: "/platform-settings/",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPeopleIndexRoute =
  AuthenticatedPeopleIndexRouteImport.update({
    id: "/people/",
    path: "/people/",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedOrganisationsIndexRoute =
  AuthenticatedOrganisationsIndexRouteImport.update({
    id: "/organisations/",
    path: "/organisations/",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedMonitoringIndexRoute =
  AuthenticatedMonitoringIndexRouteImport.update({
    id: "/monitoring/",
    path: "/monitoring/",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedLogsIndexRoute = AuthenticatedLogsIndexRouteImport.update({
  id: "/logs/",
  path: "/logs/",
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedFollowUpActionsIndexRoute =
  AuthenticatedFollowUpActionsIndexRouteImport.update({
    id: "/follow-up-actions/",
    path: "/follow-up-actions/",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedFireExtinguisherChecksIndexRoute =
  AuthenticatedFireExtinguisherChecksIndexRouteImport.update({
    id: "/fire-extinguisher-checks/",
    path: "/fire-extinguisher-checks/",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedEvidenceHubIndexRoute =
  AuthenticatedEvidenceHubIndexRouteImport.update({
    id: "/evidence-hub/",
    path: "/evidence-hub/",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedEventRecordsIndexRoute =
  AuthenticatedEventRecordsIndexRouteImport.update({
    id: "/event-records/",
    path: "/event-records/",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedEmergencyLightChecksIndexRoute =
  AuthenticatedEmergencyLightChecksIndexRouteImport.update({
    id: "/emergency-light-checks/",
    path: "/emergency-light-checks/",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedComplianceIndexRoute =
  AuthenticatedComplianceIndexRouteImport.update({
    id: "/compliance/",
    path: "/compliance/",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedComplianceManagerIndexRoute =
  AuthenticatedComplianceManagerIndexRouteImport.update({
    id: "/compliance-manager/",
    path: "/compliance-manager/",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedChecklistsIndexRoute =
  AuthenticatedChecklistsIndexRouteImport.update({
    id: "/checklists/",
    path: "/checklists/",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedChecklistManagerIndexRoute =
  AuthenticatedChecklistManagerIndexRouteImport.update({
    id: "/checklist-manager/",
    path: "/checklist-manager/",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const PrintIncidentsIncidentIdRoute =
  PrintIncidentsIncidentIdRouteImport.update({
    id: "/print/incidents/$incidentId",
    path: "/print/incidents/$incidentId",
    getParentRoute: () => rootRouteImport,
  } as any)
const PrintEventRecordsEventRecordIdRoute =
  PrintEventRecordsEventRecordIdRouteImport.update({
    id: "/print/event-records/$eventRecordId",
    path: "/print/event-records/$eventRecordId",
    getParentRoute: () => rootRouteImport,
  } as any)
const AuthenticatedPlatformSettingsStreakRulesRoute =
  AuthenticatedPlatformSettingsStreakRulesRouteImport.update({
    id: "/platform-settings/streak-rules",
    path: "/platform-settings/streak-rules",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPlatformSettingsCategoriesRoute =
  AuthenticatedPlatformSettingsCategoriesRouteImport.update({
    id: "/platform-settings/categories",
    path: "/platform-settings/categories",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPeopleNewRoute = AuthenticatedPeopleNewRouteImport.update({
  id: "/people/new",
  path: "/people/new",
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedOrganisationsSlugRoute =
  AuthenticatedOrganisationsSlugRouteImport.update({
    id: "/organisations/$slug",
    path: "/organisations/$slug",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedLogsLogTypeIdRoute =
  AuthenticatedLogsLogTypeIdRouteImport.update({
    id: "/logs/$logTypeId",
    path: "/logs/$logTypeId",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedIncidentsIncidentIdRoute =
  AuthenticatedIncidentsIncidentIdRouteImport.update({
    id: "/incidents/$incidentId",
    path: "/incidents/$incidentId",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedHotHoldingAlertsAlertIdRoute =
  AuthenticatedHotHoldingAlertsAlertIdRouteImport.update({
    id: "/hot-holding-alerts/$alertId",
    path: "/hot-holding-alerts/$alertId",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedFollowUpActionsCreateRoute =
  AuthenticatedFollowUpActionsCreateRouteImport.update({
    id: "/follow-up-actions/create",
    path: "/follow-up-actions/create",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedFollowUpActionsActionIdRoute =
  AuthenticatedFollowUpActionsActionIdRouteImport.update({
    id: "/follow-up-actions/$actionId",
    path: "/follow-up-actions/$actionId",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedFireExtinguisherChecksNewRoute =
  AuthenticatedFireExtinguisherChecksNewRouteImport.update({
    id: "/fire-extinguisher-checks/new",
    path: "/fire-extinguisher-checks/new",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedFireExtinguisherChecksCheckIdRoute =
  AuthenticatedFireExtinguisherChecksCheckIdRouteImport.update({
    id: "/fire-extinguisher-checks/$checkId",
    path: "/fire-extinguisher-checks/$checkId",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedEventRecordsNewRoute =
  AuthenticatedEventRecordsNewRouteImport.update({
    id: "/event-records/new",
    path: "/event-records/new",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedEventRecordsEventRecordIdRoute =
  AuthenticatedEventRecordsEventRecordIdRouteImport.update({
    id: "/event-records/$eventRecordId",
    path: "/event-records/$eventRecordId",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedEmergencyLightChecksNewRoute =
  AuthenticatedEmergencyLightChecksNewRouteImport.update({
    id: "/emergency-light-checks/new",
    path: "/emergency-light-checks/new",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedEmergencyLightChecksCheckIdRoute =
  AuthenticatedEmergencyLightChecksCheckIdRouteImport.update({
    id: "/emergency-light-checks/$checkId",
    path: "/emergency-light-checks/$checkId",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedComplianceNewRoute =
  AuthenticatedComplianceNewRouteImport.update({
    id: "/compliance/new",
    path: "/compliance/new",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedChecklistsIdRoute =
  AuthenticatedChecklistsIdRouteImport.update({
    id: "/checklists/$id",
    path: "/checklists/$id",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAcknowledgementsRequestIdRoute =
  AuthenticatedAcknowledgementsRequestIdRouteImport.update({
    id: "/acknowledgements/$requestId",
    path: "/acknowledgements/$requestId",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSettingsStaffIndexRoute =
  AuthenticatedSettingsStaffIndexRouteImport.update({
    id: "/settings/staff/",
    path: "/settings/staff/",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPeopleUserIdIndexRoute =
  AuthenticatedPeopleUserIdIndexRouteImport.update({
    id: "/people/$userId/",
    path: "/people/$userId/",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedOrganisationsSlugIndexRoute =
  AuthenticatedOrganisationsSlugIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => AuthenticatedOrganisationsSlugRoute,
  } as any)
const AuthenticatedTemplatesTemplateIdScheduleRoute =
  AuthenticatedTemplatesTemplateIdScheduleRouteImport.update({
    id: "/templates/$templateId/schedule",
    path: "/templates/$templateId/schedule",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSettingsStaffNewRoute =
  AuthenticatedSettingsStaffNewRouteImport.update({
    id: "/settings/staff/new",
    path: "/settings/staff/new",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPeopleUserIdLoginHistoryRoute =
  AuthenticatedPeopleUserIdLoginHistoryRouteImport.update({
    id: "/people/$userId/login-history",
    path: "/people/$userId/login-history",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedOrganisationsSlugTemplatesRoute =
  AuthenticatedOrganisationsSlugTemplatesRouteImport.update({
    id: "/templates",
    path: "/templates",
    getParentRoute: () => AuthenticatedOrganisationsSlugRoute,
  } as any)
const AuthenticatedOrganisationsSlugMembersRoute =
  AuthenticatedOrganisationsSlugMembersRouteImport.update({
    id: "/members",
    path: "/members",
    getParentRoute: () => AuthenticatedOrganisationsSlugRoute,
  } as any)
const AuthenticatedOrganisationsSlugConfigureRoute =
  AuthenticatedOrganisationsSlugConfigureRouteImport.update({
    id: "/configure",
    path: "/configure",
    getParentRoute: () => AuthenticatedOrganisationsSlugRoute,
  } as any)
const AuthenticatedComplianceInstanceInstanceIdRoute =
  AuthenticatedComplianceInstanceInstanceIdRouteImport.update({
    id: "/compliance/instance/$instanceId",
    path: "/compliance/instance/$instanceId",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedComplianceDefinitionDefinitionIdRoute =
  AuthenticatedComplianceDefinitionDefinitionIdRouteImport.update({
    id: "/compliance/definition/$definitionId",
    path: "/compliance/definition/$definitionId",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedComplianceDefinitionIdEditRoute =
  AuthenticatedComplianceDefinitionIdEditRouteImport.update({
    id: "/compliance/$definitionId/edit",
    path: "/compliance/$definitionId/edit",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedOrganisationsSlugBranchesIndexRoute =
  AuthenticatedOrganisationsSlugBranchesIndexRouteImport.update({
    id: "/branches/",
    path: "/branches/",
    getParentRoute: () => AuthenticatedOrganisationsSlugRoute,
  } as any)
const AuthenticatedSettingsStaffIdLoginAttemptsRoute =
  AuthenticatedSettingsStaffIdLoginAttemptsRouteImport.update({
    id: "/settings/staff/$id/login-attempts",
    path: "/settings/staff/$id/login-attempts",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSettingsStaffIdEditRoute =
  AuthenticatedSettingsStaffIdEditRouteImport.update({
    id: "/settings/staff/$id/edit",
    path: "/settings/staff/$id/edit",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedOrganisationsSlugBranchesBranchIdRoute =
  AuthenticatedOrganisationsSlugBranchesBranchIdRouteImport.update({
    id: "/branches/$branchId",
    path: "/branches/$branchId",
    getParentRoute: () => AuthenticatedOrganisationsSlugRoute,
  } as any)

export interface FileRoutesByFullPath {
  "/": typeof IndexRoute
  "/accept-invitation": typeof AcceptInvitationRoute
  "/install": typeof InstallRoute
  "/no-access": typeof NoAccessRoute
  "/print-test": typeof PrintTestRoute
  "/sync-status": typeof SyncStatusRoute
  "/~offline": typeof Char126offlineRoute
  "/forgot-password": typeof AuthForgotPasswordRoute
  "/login": typeof AuthLoginRoute
  "/register": typeof AuthRegisterRoute
  "/reset-password": typeof AuthResetPasswordRoute
  "/verify-email": typeof AuthVerifyEmailRoute
  "/dashboard": typeof AuthenticatedDashboardRoute
  "/global-templates": typeof AuthenticatedGlobalTemplatesRoute
  "/nurseries": typeof AuthenticatedNurseriesRoute
  "/rooms": typeof AuthenticatedRoomsRoute
  "/set-password": typeof AuthenticatedSetPasswordRoute
  "/acknowledgements/$requestId": typeof AuthenticatedAcknowledgementsRequestIdRoute
  "/checklists/$id": typeof AuthenticatedChecklistsIdRoute
  "/compliance/new": typeof AuthenticatedComplianceNewRoute
  "/emergency-light-checks/$checkId": typeof AuthenticatedEmergencyLightChecksCheckIdRoute
  "/emergency-light-checks/new": typeof AuthenticatedEmergencyLightChecksNewRoute
  "/event-records/$eventRecordId": typeof AuthenticatedEventRecordsEventRecordIdRoute
  "/event-records/new": typeof AuthenticatedEventRecordsNewRoute
  "/fire-extinguisher-checks/$checkId": typeof AuthenticatedFireExtinguisherChecksCheckIdRoute
  "/fire-extinguisher-checks/new": typeof AuthenticatedFireExtinguisherChecksNewRoute
  "/follow-up-actions/$actionId": typeof AuthenticatedFollowUpActionsActionIdRoute
  "/follow-up-actions/create": typeof AuthenticatedFollowUpActionsCreateRoute
  "/hot-holding-alerts/$alertId": typeof AuthenticatedHotHoldingAlertsAlertIdRoute
  "/incidents/$incidentId": typeof AuthenticatedIncidentsIncidentIdRoute
  "/logs/$logTypeId": typeof AuthenticatedLogsLogTypeIdRoute
  "/organisations/$slug": typeof AuthenticatedOrganisationsSlugRouteWithChildren
  "/people/new": typeof AuthenticatedPeopleNewRoute
  "/platform-settings/categories": typeof AuthenticatedPlatformSettingsCategoriesRoute
  "/platform-settings/streak-rules": typeof AuthenticatedPlatformSettingsStreakRulesRoute
  "/print/event-records/$eventRecordId": typeof PrintEventRecordsEventRecordIdRoute
  "/print/incidents/$incidentId": typeof PrintIncidentsIncidentIdRoute
  "/checklist-manager/": typeof AuthenticatedChecklistManagerIndexRoute
  "/checklists/": typeof AuthenticatedChecklistsIndexRoute
  "/compliance-manager/": typeof AuthenticatedComplianceManagerIndexRoute
  "/compliance/": typeof AuthenticatedComplianceIndexRoute
  "/emergency-light-checks/": typeof AuthenticatedEmergencyLightChecksIndexRoute
  "/event-records/": typeof AuthenticatedEventRecordsIndexRoute
  "/evidence-hub/": typeof AuthenticatedEvidenceHubIndexRoute
  "/fire-extinguisher-checks/": typeof AuthenticatedFireExtinguisherChecksIndexRoute
  "/follow-up-actions/": typeof AuthenticatedFollowUpActionsIndexRoute
  "/logs/": typeof AuthenticatedLogsIndexRoute
  "/monitoring/": typeof AuthenticatedMonitoringIndexRoute
  "/organisations/": typeof AuthenticatedOrganisationsIndexRoute
  "/people/": typeof AuthenticatedPeopleIndexRoute
  "/platform-settings/": typeof AuthenticatedPlatformSettingsIndexRoute
  "/settings/": typeof AuthenticatedSettingsIndexRoute
  "/task-manager/": typeof AuthenticatedTaskManagerIndexRoute
  "/templates/": typeof AuthenticatedTemplatesIndexRoute
  "/compliance/$definitionId/edit": typeof AuthenticatedComplianceDefinitionIdEditRoute
  "/compliance/definition/$definitionId": typeof AuthenticatedComplianceDefinitionDefinitionIdRoute
  "/compliance/instance/$instanceId": typeof AuthenticatedComplianceInstanceInstanceIdRoute
  "/organisations/$slug/configure": typeof AuthenticatedOrganisationsSlugConfigureRoute
  "/organisations/$slug/members": typeof AuthenticatedOrganisationsSlugMembersRoute
  "/organisations/$slug/templates": typeof AuthenticatedOrganisationsSlugTemplatesRoute
  "/people/$userId/login-history": typeof AuthenticatedPeopleUserIdLoginHistoryRoute
  "/settings/staff/new": typeof AuthenticatedSettingsStaffNewRoute
  "/templates/$templateId/schedule": typeof AuthenticatedTemplatesTemplateIdScheduleRoute
  "/organisations/$slug/": typeof AuthenticatedOrganisationsSlugIndexRoute
  "/people/$userId/": typeof AuthenticatedPeopleUserIdIndexRoute
  "/settings/staff/": typeof AuthenticatedSettingsStaffIndexRoute
  "/organisations/$slug/branches/$branchId": typeof AuthenticatedOrganisationsSlugBranchesBranchIdRoute
  "/settings/staff/$id/edit": typeof AuthenticatedSettingsStaffIdEditRoute
  "/settings/staff/$id/login-attempts": typeof AuthenticatedSettingsStaffIdLoginAttemptsRoute
  "/organisations/$slug/branches/": typeof AuthenticatedOrganisationsSlugBranchesIndexRoute
}
export interface FileRoutesByTo {
  "/": typeof IndexRoute
  "/accept-invitation": typeof AcceptInvitationRoute
  "/install": typeof InstallRoute
  "/no-access": typeof NoAccessRoute
  "/print-test": typeof PrintTestRoute
  "/sync-status": typeof SyncStatusRoute
  "/~offline": typeof Char126offlineRoute
  "/forgot-password": typeof AuthForgotPasswordRoute
  "/login": typeof AuthLoginRoute
  "/register": typeof AuthRegisterRoute
  "/reset-password": typeof AuthResetPasswordRoute
  "/verify-email": typeof AuthVerifyEmailRoute
  "/dashboard": typeof AuthenticatedDashboardRoute
  "/global-templates": typeof AuthenticatedGlobalTemplatesRoute
  "/nurseries": typeof AuthenticatedNurseriesRoute
  "/rooms": typeof AuthenticatedRoomsRoute
  "/set-password": typeof AuthenticatedSetPasswordRoute
  "/acknowledgements/$requestId": typeof AuthenticatedAcknowledgementsRequestIdRoute
  "/checklists/$id": typeof AuthenticatedChecklistsIdRoute
  "/compliance/new": typeof AuthenticatedComplianceNewRoute
  "/emergency-light-checks/$checkId": typeof AuthenticatedEmergencyLightChecksCheckIdRoute
  "/emergency-light-checks/new": typeof AuthenticatedEmergencyLightChecksNewRoute
  "/event-records/$eventRecordId": typeof AuthenticatedEventRecordsEventRecordIdRoute
  "/event-records/new": typeof AuthenticatedEventRecordsNewRoute
  "/fire-extinguisher-checks/$checkId": typeof AuthenticatedFireExtinguisherChecksCheckIdRoute
  "/fire-extinguisher-checks/new": typeof AuthenticatedFireExtinguisherChecksNewRoute
  "/follow-up-actions/$actionId": typeof AuthenticatedFollowUpActionsActionIdRoute
  "/follow-up-actions/create": typeof AuthenticatedFollowUpActionsCreateRoute
  "/hot-holding-alerts/$alertId": typeof AuthenticatedHotHoldingAlertsAlertIdRoute
  "/incidents/$incidentId": typeof AuthenticatedIncidentsIncidentIdRoute
  "/logs/$logTypeId": typeof AuthenticatedLogsLogTypeIdRoute
  "/people/new": typeof AuthenticatedPeopleNewRoute
  "/platform-settings/categories": typeof AuthenticatedPlatformSettingsCategoriesRoute
  "/platform-settings/streak-rules": typeof AuthenticatedPlatformSettingsStreakRulesRoute
  "/print/event-records/$eventRecordId": typeof PrintEventRecordsEventRecordIdRoute
  "/print/incidents/$incidentId": typeof PrintIncidentsIncidentIdRoute
  "/checklist-manager": typeof AuthenticatedChecklistManagerIndexRoute
  "/checklists": typeof AuthenticatedChecklistsIndexRoute
  "/compliance-manager": typeof AuthenticatedComplianceManagerIndexRoute
  "/compliance": typeof AuthenticatedComplianceIndexRoute
  "/emergency-light-checks": typeof AuthenticatedEmergencyLightChecksIndexRoute
  "/event-records": typeof AuthenticatedEventRecordsIndexRoute
  "/evidence-hub": typeof AuthenticatedEvidenceHubIndexRoute
  "/fire-extinguisher-checks": typeof AuthenticatedFireExtinguisherChecksIndexRoute
  "/follow-up-actions": typeof AuthenticatedFollowUpActionsIndexRoute
  "/logs": typeof AuthenticatedLogsIndexRoute
  "/monitoring": typeof AuthenticatedMonitoringIndexRoute
  "/organisations": typeof AuthenticatedOrganisationsIndexRoute
  "/people": typeof AuthenticatedPeopleIndexRoute
  "/platform-settings": typeof AuthenticatedPlatformSettingsIndexRoute
  "/settings": typeof AuthenticatedSettingsIndexRoute
  "/task-manager": typeof AuthenticatedTaskManagerIndexRoute
  "/templates": typeof AuthenticatedTemplatesIndexRoute
  "/compliance/$definitionId/edit": typeof AuthenticatedComplianceDefinitionIdEditRoute
  "/compliance/definition/$definitionId": typeof AuthenticatedComplianceDefinitionDefinitionIdRoute
  "/compliance/instance/$instanceId": typeof AuthenticatedComplianceInstanceInstanceIdRoute
  "/organisations/$slug/configure": typeof AuthenticatedOrganisationsSlugConfigureRoute
  "/organisations/$slug/members": typeof AuthenticatedOrganisationsSlugMembersRoute
  "/organisations/$slug/templates": typeof AuthenticatedOrganisationsSlugTemplatesRoute
  "/people/$userId/login-history": typeof AuthenticatedPeopleUserIdLoginHistoryRoute
  "/settings/staff/new": typeof AuthenticatedSettingsStaffNewRoute
  "/templates/$templateId/schedule": typeof AuthenticatedTemplatesTemplateIdScheduleRoute
  "/organisations/$slug": typeof AuthenticatedOrganisationsSlugIndexRoute
  "/people/$userId": typeof AuthenticatedPeopleUserIdIndexRoute
  "/settings/staff": typeof AuthenticatedSettingsStaffIndexRoute
  "/organisations/$slug/branches/$branchId": typeof AuthenticatedOrganisationsSlugBranchesBranchIdRoute
  "/settings/staff/$id/edit": typeof AuthenticatedSettingsStaffIdEditRoute
  "/settings/staff/$id/login-attempts": typeof AuthenticatedSettingsStaffIdLoginAttemptsRoute
  "/organisations/$slug/branches": typeof AuthenticatedOrganisationsSlugBranchesIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  "/": typeof IndexRoute
  "/_auth": typeof AuthRouteWithChildren
  "/_authenticated": typeof AuthenticatedRouteWithChildren
  "/accept-invitation": typeof AcceptInvitationRoute
  "/install": typeof InstallRoute
  "/no-access": typeof NoAccessRoute
  "/print-test": typeof PrintTestRoute
  "/sync-status": typeof SyncStatusRoute
  "/~offline": typeof Char126offlineRoute
  "/_auth/forgot-password": typeof AuthForgotPasswordRoute
  "/_auth/login": typeof AuthLoginRoute
  "/_auth/register": typeof AuthRegisterRoute
  "/_auth/reset-password": typeof AuthResetPasswordRoute
  "/_auth/verify-email": typeof AuthVerifyEmailRoute
  "/_authenticated/dashboard": typeof AuthenticatedDashboardRoute
  "/_authenticated/global-templates": typeof AuthenticatedGlobalTemplatesRoute
  "/_authenticated/nurseries": typeof AuthenticatedNurseriesRoute
  "/_authenticated/rooms": typeof AuthenticatedRoomsRoute
  "/_authenticated/set-password": typeof AuthenticatedSetPasswordRoute
  "/_authenticated/acknowledgements/$requestId": typeof AuthenticatedAcknowledgementsRequestIdRoute
  "/_authenticated/checklists/$id": typeof AuthenticatedChecklistsIdRoute
  "/_authenticated/compliance/new": typeof AuthenticatedComplianceNewRoute
  "/_authenticated/emergency-light-checks/$checkId": typeof AuthenticatedEmergencyLightChecksCheckIdRoute
  "/_authenticated/emergency-light-checks/new": typeof AuthenticatedEmergencyLightChecksNewRoute
  "/_authenticated/event-records/$eventRecordId": typeof AuthenticatedEventRecordsEventRecordIdRoute
  "/_authenticated/event-records/new": typeof AuthenticatedEventRecordsNewRoute
  "/_authenticated/fire-extinguisher-checks/$checkId": typeof AuthenticatedFireExtinguisherChecksCheckIdRoute
  "/_authenticated/fire-extinguisher-checks/new": typeof AuthenticatedFireExtinguisherChecksNewRoute
  "/_authenticated/follow-up-actions/$actionId": typeof AuthenticatedFollowUpActionsActionIdRoute
  "/_authenticated/follow-up-actions/create": typeof AuthenticatedFollowUpActionsCreateRoute
  "/_authenticated/hot-holding-alerts/$alertId": typeof AuthenticatedHotHoldingAlertsAlertIdRoute
  "/_authenticated/incidents/$incidentId": typeof AuthenticatedIncidentsIncidentIdRoute
  "/_authenticated/logs/$logTypeId": typeof AuthenticatedLogsLogTypeIdRoute
  "/_authenticated/organisations/$slug": typeof AuthenticatedOrganisationsSlugRouteWithChildren
  "/_authenticated/people/new": typeof AuthenticatedPeopleNewRoute
  "/_authenticated/platform-settings/categories": typeof AuthenticatedPlatformSettingsCategoriesRoute
  "/_authenticated/platform-settings/streak-rules": typeof AuthenticatedPlatformSettingsStreakRulesRoute
  "/print/event-records/$eventRecordId": typeof PrintEventRecordsEventRecordIdRoute
  "/print/incidents/$incidentId": typeof PrintIncidentsIncidentIdRoute
  "/_authenticated/checklist-manager/": typeof AuthenticatedChecklistManagerIndexRoute
  "/_authenticated/checklists/": typeof AuthenticatedChecklistsIndexRoute
  "/_authenticated/compliance-manager/": typeof AuthenticatedComplianceManagerIndexRoute
  "/_authenticated/compliance/": typeof AuthenticatedComplianceIndexRoute
  "/_authenticated/emergency-light-checks/": typeof AuthenticatedEmergencyLightChecksIndexRoute
  "/_authenticated/event-records/": typeof AuthenticatedEventRecordsIndexRoute
  "/_authenticated/evidence-hub/": typeof AuthenticatedEvidenceHubIndexRoute
  "/_authenticated/fire-extinguisher-checks/": typeof AuthenticatedFireExtinguisherChecksIndexRoute
  "/_authenticated/follow-up-actions/": typeof AuthenticatedFollowUpActionsIndexRoute
  "/_authenticated/logs/": typeof AuthenticatedLogsIndexRoute
  "/_authenticated/monitoring/": typeof AuthenticatedMonitoringIndexRoute
  "/_authenticated/organisations/": typeof AuthenticatedOrganisationsIndexRoute
  "/_authenticated/people/": typeof AuthenticatedPeopleIndexRoute
  "/_authenticated/platform-settings/": typeof AuthenticatedPlatformSettingsIndexRoute
  "/_authenticated/settings/": typeof AuthenticatedSettingsIndexRoute
  "/_authenticated/task-manager/": typeof AuthenticatedTaskManagerIndexRoute
  "/_authenticated/templates/": typeof AuthenticatedTemplatesIndexRoute
  "/_authenticated/compliance/$definitionId/edit": typeof AuthenticatedComplianceDefinitionIdEditRoute
  "/_authenticated/compliance/definition/$definitionId": typeof AuthenticatedComplianceDefinitionDefinitionIdRoute
  "/_authenticated/compliance/instance/$instanceId": typeof AuthenticatedComplianceInstanceInstanceIdRoute
  "/_authenticated/organisations/$slug/configure": typeof AuthenticatedOrganisationsSlugConfigureRoute
  "/_authenticated/organisations/$slug/members": typeof AuthenticatedOrganisationsSlugMembersRoute
  "/_authenticated/organisations/$slug/templates": typeof AuthenticatedOrganisationsSlugTemplatesRoute
  "/_authenticated/people/$userId/login-history": typeof AuthenticatedPeopleUserIdLoginHistoryRoute
  "/_authenticated/settings/staff/new": typeof AuthenticatedSettingsStaffNewRoute
  "/_authenticated/templates/$templateId/schedule": typeof AuthenticatedTemplatesTemplateIdScheduleRoute
  "/_authenticated/organisations/$slug/": typeof AuthenticatedOrganisationsSlugIndexRoute
  "/_authenticated/people/$userId/": typeof AuthenticatedPeopleUserIdIndexRoute
  "/_authenticated/settings/staff/": typeof AuthenticatedSettingsStaffIndexRoute
  "/_authenticated/organisations/$slug/branches/$branchId": typeof AuthenticatedOrganisationsSlugBranchesBranchIdRoute
  "/_authenticated/settings/staff/$id/edit": typeof AuthenticatedSettingsStaffIdEditRoute
  "/_authenticated/settings/staff/$id/login-attempts": typeof AuthenticatedSettingsStaffIdLoginAttemptsRoute
  "/_authenticated/organisations/$slug/branches/": typeof AuthenticatedOrganisationsSlugBranchesIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | "/"
    | "/accept-invitation"
    | "/install"
    | "/no-access"
    | "/print-test"
    | "/sync-status"
    | "/~offline"
    | "/forgot-password"
    | "/login"
    | "/register"
    | "/reset-password"
    | "/verify-email"
    | "/dashboard"
    | "/global-templates"
    | "/nurseries"
    | "/rooms"
    | "/set-password"
    | "/acknowledgements/$requestId"
    | "/checklists/$id"
    | "/compliance/new"
    | "/emergency-light-checks/$checkId"
    | "/emergency-light-checks/new"
    | "/event-records/$eventRecordId"
    | "/event-records/new"
    | "/fire-extinguisher-checks/$checkId"
    | "/fire-extinguisher-checks/new"
    | "/follow-up-actions/$actionId"
    | "/follow-up-actions/create"
    | "/hot-holding-alerts/$alertId"
    | "/incidents/$incidentId"
    | "/logs/$logTypeId"
    | "/organisations/$slug"
    | "/people/new"
    | "/platform-settings/categories"
    | "/platform-settings/streak-rules"
    | "/print/event-records/$eventRecordId"
    | "/print/incidents/$incidentId"
    | "/checklist-manager/"
    | "/checklists/"
    | "/compliance-manager/"
    | "/compliance/"
    | "/emergency-light-checks/"
    | "/event-records/"
    | "/evidence-hub/"
    | "/fire-extinguisher-checks/"
    | "/follow-up-actions/"
    | "/logs/"
    | "/monitoring/"
    | "/organisations/"
    | "/people/"
    | "/platform-settings/"
    | "/settings/"
    | "/task-manager/"
    | "/templates/"
    | "/compliance/$definitionId/edit"
    | "/compliance/definition/$definitionId"
    | "/compliance/instance/$instanceId"
    | "/organisations/$slug/configure"
    | "/organisations/$slug/members"
    | "/organisations/$slug/templates"
    | "/people/$userId/login-history"
    | "/settings/staff/new"
    | "/templates/$templateId/schedule"
    | "/organisations/$slug/"
    | "/people/$userId/"
    | "/settings/staff/"
    | "/organisations/$slug/branches/$branchId"
    | "/settings/staff/$id/edit"
    | "/settings/staff/$id/login-attempts"
    | "/organisations/$slug/branches/"
  fileRoutesByTo: FileRoutesByTo
  to:
    | "/"
    | "/accept-invitation"
    | "/install"
    | "/no-access"
    | "/print-test"
    | "/sync-status"
    | "/~offline"
    | "/forgot-password"
    | "/login"
    | "/register"
    | "/reset-password"
    | "/verify-email"
    | "/dashboard"
    | "/global-templates"
    | "/nurseries"
    | "/rooms"
    | "/set-password"
    | "/acknowledgements/$requestId"
    | "/checklists/$id"
    | "/compliance/new"
    | "/emergency-light-checks/$checkId"
    | "/emergency-light-checks/new"
    | "/event-records/$eventRecordId"
    | "/event-records/new"
    | "/fire-extinguisher-checks/$checkId"
    | "/fire-extinguisher-checks/new"
    | "/follow-up-actions/$actionId"
    | "/follow-up-actions/create"
    | "/hot-holding-alerts/$alertId"
    | "/incidents/$incidentId"
    | "/logs/$logTypeId"
    | "/people/new"
    | "/platform-settings/categories"
    | "/platform-settings/streak-rules"
    | "/print/event-records/$eventRecordId"
    | "/print/incidents/$incidentId"
    | "/checklist-manager"
    | "/checklists"
    | "/compliance-manager"
    | "/compliance"
    | "/emergency-light-checks"
    | "/event-records"
    | "/evidence-hub"
    | "/fire-extinguisher-checks"
    | "/follow-up-actions"
    | "/logs"
    | "/monitoring"
    | "/organisations"
    | "/people"
    | "/platform-settings"
    | "/settings"
    | "/task-manager"
    | "/templates"
    | "/compliance/$definitionId/edit"
    | "/compliance/definition/$definitionId"
    | "/compliance/instance/$instanceId"
    | "/organisations/$slug/configure"
    | "/organisations/$slug/members"
    | "/organisations/$slug/templates"
    | "/people/$userId/login-history"
    | "/settings/staff/new"
    | "/templates/$templateId/schedule"
    | "/organisations/$slug"
    | "/people/$userId"
    | "/settings/staff"
    | "/organisations/$slug/branches/$branchId"
    | "/settings/staff/$id/edit"
    | "/settings/staff/$id/login-attempts"
    | "/organisations/$slug/branches"
  id:
    | "__root__"
    | "/"
    | "/_auth"
    | "/_authenticated"
    | "/accept-invitation"
    | "/install"
    | "/no-access"
    | "/print-test"
    | "/sync-status"
    | "/~offline"
    | "/_auth/forgot-password"
    | "/_auth/login"
    | "/_auth/register"
    | "/_auth/reset-password"
    | "/_auth/verify-email"
    | "/_authenticated/dashboard"
    | "/_authenticated/global-templates"
    | "/_authenticated/nurseries"
    | "/_authenticated/rooms"
    | "/_authenticated/set-password"
    | "/_authenticated/acknowledgements/$requestId"
    | "/_authenticated/checklists/$id"
    | "/_authenticated/compliance/new"
    | "/_authenticated/emergency-light-checks/$checkId"
    | "/_authenticated/emergency-light-checks/new"
    | "/_authenticated/event-records/$eventRecordId"
    | "/_authenticated/event-records/new"
    | "/_authenticated/fire-extinguisher-checks/$checkId"
    | "/_authenticated/fire-extinguisher-checks/new"
    | "/_authenticated/follow-up-actions/$actionId"
    | "/_authenticated/follow-up-actions/create"
    | "/_authenticated/hot-holding-alerts/$alertId"
    | "/_authenticated/incidents/$incidentId"
    | "/_authenticated/logs/$logTypeId"
    | "/_authenticated/organisations/$slug"
    | "/_authenticated/people/new"
    | "/_authenticated/platform-settings/categories"
    | "/_authenticated/platform-settings/streak-rules"
    | "/print/event-records/$eventRecordId"
    | "/print/incidents/$incidentId"
    | "/_authenticated/checklist-manager/"
    | "/_authenticated/checklists/"
    | "/_authenticated/compliance-manager/"
    | "/_authenticated/compliance/"
    | "/_authenticated/emergency-light-checks/"
    | "/_authenticated/event-records/"
    | "/_authenticated/evidence-hub/"
    | "/_authenticated/fire-extinguisher-checks/"
    | "/_authenticated/follow-up-actions/"
    | "/_authenticated/logs/"
    | "/_authenticated/monitoring/"
    | "/_authenticated/organisations/"
    | "/_authenticated/people/"
    | "/_authenticated/platform-settings/"
    | "/_authenticated/settings/"
    | "/_authenticated/task-manager/"
    | "/_authenticated/templates/"
    | "/_authenticated/compliance/$definitionId/edit"
    | "/_authenticated/compliance/definition/$definitionId"
    | "/_authenticated/compliance/instance/$instanceId"
    | "/_authenticated/organisations/$slug/configure"
    | "/_authenticated/organisations/$slug/members"
    | "/_authenticated/organisations/$slug/templates"
    | "/_authenticated/people/$userId/login-history"
    | "/_authenticated/settings/staff/new"
    | "/_authenticated/templates/$templateId/schedule"
    | "/_authenticated/organisations/$slug/"
    | "/_authenticated/people/$userId/"
    | "/_authenticated/settings/staff/"
    | "/_authenticated/organisations/$slug/branches/$branchId"
    | "/_authenticated/settings/staff/$id/edit"
    | "/_authenticated/settings/staff/$id/login-attempts"
    | "/_authenticated/organisations/$slug/branches/"
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthRoute: typeof AuthRouteWithChildren
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  AcceptInvitationRoute: typeof AcceptInvitationRoute
  InstallRoute: typeof InstallRoute
  NoAccessRoute: typeof NoAccessRoute
  PrintTestRoute: typeof PrintTestRoute
  SyncStatusRoute: typeof SyncStatusRoute
  Char126offlineRoute: typeof Char126offlineRoute
  PrintEventRecordsEventRecordIdRoute: typeof PrintEventRecordsEventRecordIdRoute
  PrintIncidentsIncidentIdRoute: typeof PrintIncidentsIncidentIdRoute
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/~offline": {
      id: "/~offline"
      path: "/~offline"
      fullPath: "/~offline"
      preLoaderRoute: typeof Char126offlineRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/sync-status": {
      id: "/sync-status"
      path: "/sync-status"
      fullPath: "/sync-status"
      preLoaderRoute: typeof SyncStatusRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/print-test": {
      id: "/print-test"
      path: "/print-test"
      fullPath: "/print-test"
      preLoaderRoute: typeof PrintTestRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/no-access": {
      id: "/no-access"
      path: "/no-access"
      fullPath: "/no-access"
      preLoaderRoute: typeof NoAccessRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/install": {
      id: "/install"
      path: "/install"
      fullPath: "/install"
      preLoaderRoute: typeof InstallRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/accept-invitation": {
      id: "/accept-invitation"
      path: "/accept-invitation"
      fullPath: "/accept-invitation"
      preLoaderRoute: typeof AcceptInvitationRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_authenticated": {
      id: "/_authenticated"
      path: ""
      fullPath: "/"
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_auth": {
      id: "/_auth"
      path: ""
      fullPath: "/"
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/": {
      id: "/"
      path: "/"
      fullPath: "/"
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_authenticated/set-password": {
      id: "/_authenticated/set-password"
      path: "/set-password"
      fullPath: "/set-password"
      preLoaderRoute: typeof AuthenticatedSetPasswordRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/rooms": {
      id: "/_authenticated/rooms"
      path: "/rooms"
      fullPath: "/rooms"
      preLoaderRoute: typeof AuthenticatedRoomsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/nurseries": {
      id: "/_authenticated/nurseries"
      path: "/nurseries"
      fullPath: "/nurseries"
      preLoaderRoute: typeof AuthenticatedNurseriesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/global-templates": {
      id: "/_authenticated/global-templates"
      path: "/global-templates"
      fullPath: "/global-templates"
      preLoaderRoute: typeof AuthenticatedGlobalTemplatesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/dashboard": {
      id: "/_authenticated/dashboard"
      path: "/dashboard"
      fullPath: "/dashboard"
      preLoaderRoute: typeof AuthenticatedDashboardRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_auth/verify-email": {
      id: "/_auth/verify-email"
      path: "/verify-email"
      fullPath: "/verify-email"
      preLoaderRoute: typeof AuthVerifyEmailRouteImport
      parentRoute: typeof AuthRoute
    }
    "/_auth/reset-password": {
      id: "/_auth/reset-password"
      path: "/reset-password"
      fullPath: "/reset-password"
      preLoaderRoute: typeof AuthResetPasswordRouteImport
      parentRoute: typeof AuthRoute
    }
    "/_auth/register": {
      id: "/_auth/register"
      path: "/register"
      fullPath: "/register"
      preLoaderRoute: typeof AuthRegisterRouteImport
      parentRoute: typeof AuthRoute
    }
    "/_auth/login": {
      id: "/_auth/login"
      path: "/login"
      fullPath: "/login"
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof AuthRoute
    }
    "/_auth/forgot-password": {
      id: "/_auth/forgot-password"
      path: "/forgot-password"
      fullPath: "/forgot-password"
      preLoaderRoute: typeof AuthForgotPasswordRouteImport
      parentRoute: typeof AuthRoute
    }
    "/_authenticated/templates/": {
      id: "/_authenticated/templates/"
      path: "/templates"
      fullPath: "/templates/"
      preLoaderRoute: typeof AuthenticatedTemplatesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/task-manager/": {
      id: "/_authenticated/task-manager/"
      path: "/task-manager"
      fullPath: "/task-manager/"
      preLoaderRoute: typeof AuthenticatedTaskManagerIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/settings/": {
      id: "/_authenticated/settings/"
      path: "/settings"
      fullPath: "/settings/"
      preLoaderRoute: typeof AuthenticatedSettingsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/platform-settings/": {
      id: "/_authenticated/platform-settings/"
      path: "/platform-settings"
      fullPath: "/platform-settings/"
      preLoaderRoute: typeof AuthenticatedPlatformSettingsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/people/": {
      id: "/_authenticated/people/"
      path: "/people"
      fullPath: "/people/"
      preLoaderRoute: typeof AuthenticatedPeopleIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/organisations/": {
      id: "/_authenticated/organisations/"
      path: "/organisations"
      fullPath: "/organisations/"
      preLoaderRoute: typeof AuthenticatedOrganisationsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/monitoring/": {
      id: "/_authenticated/monitoring/"
      path: "/monitoring"
      fullPath: "/monitoring/"
      preLoaderRoute: typeof AuthenticatedMonitoringIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/logs/": {
      id: "/_authenticated/logs/"
      path: "/logs"
      fullPath: "/logs/"
      preLoaderRoute: typeof AuthenticatedLogsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/follow-up-actions/": {
      id: "/_authenticated/follow-up-actions/"
      path: "/follow-up-actions"
      fullPath: "/follow-up-actions/"
      preLoaderRoute: typeof AuthenticatedFollowUpActionsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/fire-extinguisher-checks/": {
      id: "/_authenticated/fire-extinguisher-checks/"
      path: "/fire-extinguisher-checks"
      fullPath: "/fire-extinguisher-checks/"
      preLoaderRoute: typeof AuthenticatedFireExtinguisherChecksIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/evidence-hub/": {
      id: "/_authenticated/evidence-hub/"
      path: "/evidence-hub"
      fullPath: "/evidence-hub/"
      preLoaderRoute: typeof AuthenticatedEvidenceHubIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/event-records/": {
      id: "/_authenticated/event-records/"
      path: "/event-records"
      fullPath: "/event-records/"
      preLoaderRoute: typeof AuthenticatedEventRecordsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/emergency-light-checks/": {
      id: "/_authenticated/emergency-light-checks/"
      path: "/emergency-light-checks"
      fullPath: "/emergency-light-checks/"
      preLoaderRoute: typeof AuthenticatedEmergencyLightChecksIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/compliance/": {
      id: "/_authenticated/compliance/"
      path: "/compliance"
      fullPath: "/compliance/"
      preLoaderRoute: typeof AuthenticatedComplianceIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/compliance-manager/": {
      id: "/_authenticated/compliance-manager/"
      path: "/compliance-manager"
      fullPath: "/compliance-manager/"
      preLoaderRoute: typeof AuthenticatedComplianceManagerIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/checklists/": {
      id: "/_authenticated/checklists/"
      path: "/checklists"
      fullPath: "/checklists/"
      preLoaderRoute: typeof AuthenticatedChecklistsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/checklist-manager/": {
      id: "/_authenticated/checklist-manager/"
      path: "/checklist-manager"
      fullPath: "/checklist-manager/"
      preLoaderRoute: typeof AuthenticatedChecklistManagerIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/print/incidents/$incidentId": {
      id: "/print/incidents/$incidentId"
      path: "/print/incidents/$incidentId"
      fullPath: "/print/incidents/$incidentId"
      preLoaderRoute: typeof PrintIncidentsIncidentIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/print/event-records/$eventRecordId": {
      id: "/print/event-records/$eventRecordId"
      path: "/print/event-records/$eventRecordId"
      fullPath: "/print/event-records/$eventRecordId"
      preLoaderRoute: typeof PrintEventRecordsEventRecordIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_authenticated/platform-settings/streak-rules": {
      id: "/_authenticated/platform-settings/streak-rules"
      path: "/platform-settings/streak-rules"
      fullPath: "/platform-settings/streak-rules"
      preLoaderRoute: typeof AuthenticatedPlatformSettingsStreakRulesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/platform-settings/categories": {
      id: "/_authenticated/platform-settings/categories"
      path: "/platform-settings/categories"
      fullPath: "/platform-settings/categories"
      preLoaderRoute: typeof AuthenticatedPlatformSettingsCategoriesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/people/new": {
      id: "/_authenticated/people/new"
      path: "/people/new"
      fullPath: "/people/new"
      preLoaderRoute: typeof AuthenticatedPeopleNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/organisations/$slug": {
      id: "/_authenticated/organisations/$slug"
      path: "/organisations/$slug"
      fullPath: "/organisations/$slug"
      preLoaderRoute: typeof AuthenticatedOrganisationsSlugRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/logs/$logTypeId": {
      id: "/_authenticated/logs/$logTypeId"
      path: "/logs/$logTypeId"
      fullPath: "/logs/$logTypeId"
      preLoaderRoute: typeof AuthenticatedLogsLogTypeIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/incidents/$incidentId": {
      id: "/_authenticated/incidents/$incidentId"
      path: "/incidents/$incidentId"
      fullPath: "/incidents/$incidentId"
      preLoaderRoute: typeof AuthenticatedIncidentsIncidentIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/hot-holding-alerts/$alertId": {
      id: "/_authenticated/hot-holding-alerts/$alertId"
      path: "/hot-holding-alerts/$alertId"
      fullPath: "/hot-holding-alerts/$alertId"
      preLoaderRoute: typeof AuthenticatedHotHoldingAlertsAlertIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/follow-up-actions/create": {
      id: "/_authenticated/follow-up-actions/create"
      path: "/follow-up-actions/create"
      fullPath: "/follow-up-actions/create"
      preLoaderRoute: typeof AuthenticatedFollowUpActionsCreateRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/follow-up-actions/$actionId": {
      id: "/_authenticated/follow-up-actions/$actionId"
      path: "/follow-up-actions/$actionId"
      fullPath: "/follow-up-actions/$actionId"
      preLoaderRoute: typeof AuthenticatedFollowUpActionsActionIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/fire-extinguisher-checks/new": {
      id: "/_authenticated/fire-extinguisher-checks/new"
      path: "/fire-extinguisher-checks/new"
      fullPath: "/fire-extinguisher-checks/new"
      preLoaderRoute: typeof AuthenticatedFireExtinguisherChecksNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/fire-extinguisher-checks/$checkId": {
      id: "/_authenticated/fire-extinguisher-checks/$checkId"
      path: "/fire-extinguisher-checks/$checkId"
      fullPath: "/fire-extinguisher-checks/$checkId"
      preLoaderRoute: typeof AuthenticatedFireExtinguisherChecksCheckIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/event-records/new": {
      id: "/_authenticated/event-records/new"
      path: "/event-records/new"
      fullPath: "/event-records/new"
      preLoaderRoute: typeof AuthenticatedEventRecordsNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/event-records/$eventRecordId": {
      id: "/_authenticated/event-records/$eventRecordId"
      path: "/event-records/$eventRecordId"
      fullPath: "/event-records/$eventRecordId"
      preLoaderRoute: typeof AuthenticatedEventRecordsEventRecordIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/emergency-light-checks/new": {
      id: "/_authenticated/emergency-light-checks/new"
      path: "/emergency-light-checks/new"
      fullPath: "/emergency-light-checks/new"
      preLoaderRoute: typeof AuthenticatedEmergencyLightChecksNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/emergency-light-checks/$checkId": {
      id: "/_authenticated/emergency-light-checks/$checkId"
      path: "/emergency-light-checks/$checkId"
      fullPath: "/emergency-light-checks/$checkId"
      preLoaderRoute: typeof AuthenticatedEmergencyLightChecksCheckIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/compliance/new": {
      id: "/_authenticated/compliance/new"
      path: "/compliance/new"
      fullPath: "/compliance/new"
      preLoaderRoute: typeof AuthenticatedComplianceNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/checklists/$id": {
      id: "/_authenticated/checklists/$id"
      path: "/checklists/$id"
      fullPath: "/checklists/$id"
      preLoaderRoute: typeof AuthenticatedChecklistsIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/acknowledgements/$requestId": {
      id: "/_authenticated/acknowledgements/$requestId"
      path: "/acknowledgements/$requestId"
      fullPath: "/acknowledgements/$requestId"
      preLoaderRoute: typeof AuthenticatedAcknowledgementsRequestIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/settings/staff/": {
      id: "/_authenticated/settings/staff/"
      path: "/settings/staff"
      fullPath: "/settings/staff/"
      preLoaderRoute: typeof AuthenticatedSettingsStaffIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/people/$userId/": {
      id: "/_authenticated/people/$userId/"
      path: "/people/$userId"
      fullPath: "/people/$userId/"
      preLoaderRoute: typeof AuthenticatedPeopleUserIdIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/organisations/$slug/": {
      id: "/_authenticated/organisations/$slug/"
      path: "/"
      fullPath: "/organisations/$slug/"
      preLoaderRoute: typeof AuthenticatedOrganisationsSlugIndexRouteImport
      parentRoute: typeof AuthenticatedOrganisationsSlugRoute
    }
    "/_authenticated/templates/$templateId/schedule": {
      id: "/_authenticated/templates/$templateId/schedule"
      path: "/templates/$templateId/schedule"
      fullPath: "/templates/$templateId/schedule"
      preLoaderRoute: typeof AuthenticatedTemplatesTemplateIdScheduleRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/settings/staff/new": {
      id: "/_authenticated/settings/staff/new"
      path: "/settings/staff/new"
      fullPath: "/settings/staff/new"
      preLoaderRoute: typeof AuthenticatedSettingsStaffNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/people/$userId/login-history": {
      id: "/_authenticated/people/$userId/login-history"
      path: "/people/$userId/login-history"
      fullPath: "/people/$userId/login-history"
      preLoaderRoute: typeof AuthenticatedPeopleUserIdLoginHistoryRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/organisations/$slug/templates": {
      id: "/_authenticated/organisations/$slug/templates"
      path: "/templates"
      fullPath: "/organisations/$slug/templates"
      preLoaderRoute: typeof AuthenticatedOrganisationsSlugTemplatesRouteImport
      parentRoute: typeof AuthenticatedOrganisationsSlugRoute
    }
    "/_authenticated/organisations/$slug/members": {
      id: "/_authenticated/organisations/$slug/members"
      path: "/members"
      fullPath: "/organisations/$slug/members"
      preLoaderRoute: typeof AuthenticatedOrganisationsSlugMembersRouteImport
      parentRoute: typeof AuthenticatedOrganisationsSlugRoute
    }
    "/_authenticated/organisations/$slug/configure": {
      id: "/_authenticated/organisations/$slug/configure"
      path: "/configure"
      fullPath: "/organisations/$slug/configure"
      preLoaderRoute: typeof AuthenticatedOrganisationsSlugConfigureRouteImport
      parentRoute: typeof AuthenticatedOrganisationsSlugRoute
    }
    "/_authenticated/compliance/instance/$instanceId": {
      id: "/_authenticated/compliance/instance/$instanceId"
      path: "/compliance/instance/$instanceId"
      fullPath: "/compliance/instance/$instanceId"
      preLoaderRoute: typeof AuthenticatedComplianceInstanceInstanceIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/compliance/definition/$definitionId": {
      id: "/_authenticated/compliance/definition/$definitionId"
      path: "/compliance/definition/$definitionId"
      fullPath: "/compliance/definition/$definitionId"
      preLoaderRoute: typeof AuthenticatedComplianceDefinitionDefinitionIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/compliance/$definitionId/edit": {
      id: "/_authenticated/compliance/$definitionId/edit"
      path: "/compliance/$definitionId/edit"
      fullPath: "/compliance/$definitionId/edit"
      preLoaderRoute: typeof AuthenticatedComplianceDefinitionIdEditRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/organisations/$slug/branches/": {
      id: "/_authenticated/organisations/$slug/branches/"
      path: "/branches"
      fullPath: "/organisations/$slug/branches/"
      preLoaderRoute: typeof AuthenticatedOrganisationsSlugBranchesIndexRouteImport
      parentRoute: typeof AuthenticatedOrganisationsSlugRoute
    }
    "/_authenticated/settings/staff/$id/login-attempts": {
      id: "/_authenticated/settings/staff/$id/login-attempts"
      path: "/settings/staff/$id/login-attempts"
      fullPath: "/settings/staff/$id/login-attempts"
      preLoaderRoute: typeof AuthenticatedSettingsStaffIdLoginAttemptsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/settings/staff/$id/edit": {
      id: "/_authenticated/settings/staff/$id/edit"
      path: "/settings/staff/$id/edit"
      fullPath: "/settings/staff/$id/edit"
      preLoaderRoute: typeof AuthenticatedSettingsStaffIdEditRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/organisations/$slug/branches/$branchId": {
      id: "/_authenticated/organisations/$slug/branches/$branchId"
      path: "/branches/$branchId"
      fullPath: "/organisations/$slug/branches/$branchId"
      preLoaderRoute: typeof AuthenticatedOrganisationsSlugBranchesBranchIdRouteImport
      parentRoute: typeof AuthenticatedOrganisationsSlugRoute
    }
  }
}

interface AuthRouteChildren {
  AuthForgotPasswordRoute: typeof AuthForgotPasswordRoute
  AuthLoginRoute: typeof AuthLoginRoute
  AuthRegisterRoute: typeof AuthRegisterRoute
  AuthResetPasswordRoute: typeof AuthResetPasswordRoute
  AuthVerifyEmailRoute: typeof AuthVerifyEmailRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthForgotPasswordRoute: AuthForgotPasswordRoute,
  AuthLoginRoute: AuthLoginRoute,
  AuthRegisterRoute: AuthRegisterRoute,
  AuthResetPasswordRoute: AuthResetPasswordRoute,
  AuthVerifyEmailRoute: AuthVerifyEmailRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

interface AuthenticatedOrganisationsSlugRouteChildren {
  AuthenticatedOrganisationsSlugConfigureRoute: typeof AuthenticatedOrganisationsSlugConfigureRoute
  AuthenticatedOrganisationsSlugMembersRoute: typeof AuthenticatedOrganisationsSlugMembersRoute
  AuthenticatedOrganisationsSlugTemplatesRoute: typeof AuthenticatedOrganisationsSlugTemplatesRoute
  AuthenticatedOrganisationsSlugIndexRoute: typeof AuthenticatedOrganisationsSlugIndexRoute
  AuthenticatedOrganisationsSlugBranchesBranchIdRoute: typeof AuthenticatedOrganisationsSlugBranchesBranchIdRoute
  AuthenticatedOrganisationsSlugBranchesIndexRoute: typeof AuthenticatedOrganisationsSlugBranchesIndexRoute
}

const AuthenticatedOrganisationsSlugRouteChildren: AuthenticatedOrganisationsSlugRouteChildren =
  {
    AuthenticatedOrganisationsSlugConfigureRoute:
      AuthenticatedOrganisationsSlugConfigureRoute,
    AuthenticatedOrganisationsSlugMembersRoute:
      AuthenticatedOrganisationsSlugMembersRoute,
    AuthenticatedOrganisationsSlugTemplatesRoute:
      AuthenticatedOrganisationsSlugTemplatesRoute,
    AuthenticatedOrganisationsSlugIndexRoute:
      AuthenticatedOrganisationsSlugIndexRoute,
    AuthenticatedOrganisationsSlugBranchesBranchIdRoute:
      AuthenticatedOrganisationsSlugBranchesBranchIdRoute,
    AuthenticatedOrganisationsSlugBranchesIndexRoute:
      AuthenticatedOrganisationsSlugBranchesIndexRoute,
  }

const AuthenticatedOrganisationsSlugRouteWithChildren =
  AuthenticatedOrganisationsSlugRoute._addFileChildren(
    AuthenticatedOrganisationsSlugRouteChildren,
  )

interface AuthenticatedRouteChildren {
  AuthenticatedDashboardRoute: typeof AuthenticatedDashboardRoute
  AuthenticatedGlobalTemplatesRoute: typeof AuthenticatedGlobalTemplatesRoute
  AuthenticatedNurseriesRoute: typeof AuthenticatedNurseriesRoute
  AuthenticatedRoomsRoute: typeof AuthenticatedRoomsRoute
  AuthenticatedSetPasswordRoute: typeof AuthenticatedSetPasswordRoute
  AuthenticatedAcknowledgementsRequestIdRoute: typeof AuthenticatedAcknowledgementsRequestIdRoute
  AuthenticatedChecklistsIdRoute: typeof AuthenticatedChecklistsIdRoute
  AuthenticatedComplianceNewRoute: typeof AuthenticatedComplianceNewRoute
  AuthenticatedEmergencyLightChecksCheckIdRoute: typeof AuthenticatedEmergencyLightChecksCheckIdRoute
  AuthenticatedEmergencyLightChecksNewRoute: typeof AuthenticatedEmergencyLightChecksNewRoute
  AuthenticatedEventRecordsEventRecordIdRoute: typeof AuthenticatedEventRecordsEventRecordIdRoute
  AuthenticatedEventRecordsNewRoute: typeof AuthenticatedEventRecordsNewRoute
  AuthenticatedFireExtinguisherChecksCheckIdRoute: typeof AuthenticatedFireExtinguisherChecksCheckIdRoute
  AuthenticatedFireExtinguisherChecksNewRoute: typeof AuthenticatedFireExtinguisherChecksNewRoute
  AuthenticatedFollowUpActionsActionIdRoute: typeof AuthenticatedFollowUpActionsActionIdRoute
  AuthenticatedFollowUpActionsCreateRoute: typeof AuthenticatedFollowUpActionsCreateRoute
  AuthenticatedHotHoldingAlertsAlertIdRoute: typeof AuthenticatedHotHoldingAlertsAlertIdRoute
  AuthenticatedIncidentsIncidentIdRoute: typeof AuthenticatedIncidentsIncidentIdRoute
  AuthenticatedLogsLogTypeIdRoute: typeof AuthenticatedLogsLogTypeIdRoute
  AuthenticatedOrganisationsSlugRoute: typeof AuthenticatedOrganisationsSlugRouteWithChildren
  AuthenticatedPeopleNewRoute: typeof AuthenticatedPeopleNewRoute
  AuthenticatedPlatformSettingsCategoriesRoute: typeof AuthenticatedPlatformSettingsCategoriesRoute
  AuthenticatedPlatformSettingsStreakRulesRoute: typeof AuthenticatedPlatformSettingsStreakRulesRoute
  AuthenticatedChecklistManagerIndexRoute: typeof AuthenticatedChecklistManagerIndexRoute
  AuthenticatedChecklistsIndexRoute: typeof AuthenticatedChecklistsIndexRoute
  AuthenticatedComplianceManagerIndexRoute: typeof AuthenticatedComplianceManagerIndexRoute
  AuthenticatedComplianceIndexRoute: typeof AuthenticatedComplianceIndexRoute
  AuthenticatedEmergencyLightChecksIndexRoute: typeof AuthenticatedEmergencyLightChecksIndexRoute
  AuthenticatedEventRecordsIndexRoute: typeof AuthenticatedEventRecordsIndexRoute
  AuthenticatedEvidenceHubIndexRoute: typeof AuthenticatedEvidenceHubIndexRoute
  AuthenticatedFireExtinguisherChecksIndexRoute: typeof AuthenticatedFireExtinguisherChecksIndexRoute
  AuthenticatedFollowUpActionsIndexRoute: typeof AuthenticatedFollowUpActionsIndexRoute
  AuthenticatedLogsIndexRoute: typeof AuthenticatedLogsIndexRoute
  AuthenticatedMonitoringIndexRoute: typeof AuthenticatedMonitoringIndexRoute
  AuthenticatedOrganisationsIndexRoute: typeof AuthenticatedOrganisationsIndexRoute
  AuthenticatedPeopleIndexRoute: typeof AuthenticatedPeopleIndexRoute
  AuthenticatedPlatformSettingsIndexRoute: typeof AuthenticatedPlatformSettingsIndexRoute
  AuthenticatedSettingsIndexRoute: typeof AuthenticatedSettingsIndexRoute
  AuthenticatedTaskManagerIndexRoute: typeof AuthenticatedTaskManagerIndexRoute
  AuthenticatedTemplatesIndexRoute: typeof AuthenticatedTemplatesIndexRoute
  AuthenticatedComplianceDefinitionIdEditRoute: typeof AuthenticatedComplianceDefinitionIdEditRoute
  AuthenticatedComplianceDefinitionDefinitionIdRoute: typeof AuthenticatedComplianceDefinitionDefinitionIdRoute
  AuthenticatedComplianceInstanceInstanceIdRoute: typeof AuthenticatedComplianceInstanceInstanceIdRoute
  AuthenticatedPeopleUserIdLoginHistoryRoute: typeof AuthenticatedPeopleUserIdLoginHistoryRoute
  AuthenticatedSettingsStaffNewRoute: typeof AuthenticatedSettingsStaffNewRoute
  AuthenticatedTemplatesTemplateIdScheduleRoute: typeof AuthenticatedTemplatesTemplateIdScheduleRoute
  AuthenticatedPeopleUserIdIndexRoute: typeof AuthenticatedPeopleUserIdIndexRoute
  AuthenticatedSettingsStaffIndexRoute: typeof AuthenticatedSettingsStaffIndexRoute
  AuthenticatedSettingsStaffIdEditRoute: typeof AuthenticatedSettingsStaffIdEditRoute
  AuthenticatedSettingsStaffIdLoginAttemptsRoute: typeof AuthenticatedSettingsStaffIdLoginAttemptsRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedDashboardRoute: AuthenticatedDashboardRoute,
  AuthenticatedGlobalTemplatesRoute: AuthenticatedGlobalTemplatesRoute,
  AuthenticatedNurseriesRoute: AuthenticatedNurseriesRoute,
  AuthenticatedRoomsRoute: AuthenticatedRoomsRoute,
  AuthenticatedSetPasswordRoute: AuthenticatedSetPasswordRoute,
  AuthenticatedAcknowledgementsRequestIdRoute:
    AuthenticatedAcknowledgementsRequestIdRoute,
  AuthenticatedChecklistsIdRoute: AuthenticatedChecklistsIdRoute,
  AuthenticatedComplianceNewRoute: AuthenticatedComplianceNewRoute,
  AuthenticatedEmergencyLightChecksCheckIdRoute:
    AuthenticatedEmergencyLightChecksCheckIdRoute,
  AuthenticatedEmergencyLightChecksNewRoute:
    AuthenticatedEmergencyLightChecksNewRoute,
  AuthenticatedEventRecordsEventRecordIdRoute:
    AuthenticatedEventRecordsEventRecordIdRoute,
  AuthenticatedEventRecordsNewRoute: AuthenticatedEventRecordsNewRoute,
  AuthenticatedFireExtinguisherChecksCheckIdRoute:
    AuthenticatedFireExtinguisherChecksCheckIdRoute,
  AuthenticatedFireExtinguisherChecksNewRoute:
    AuthenticatedFireExtinguisherChecksNewRoute,
  AuthenticatedFollowUpActionsActionIdRoute:
    AuthenticatedFollowUpActionsActionIdRoute,
  AuthenticatedFollowUpActionsCreateRoute:
    AuthenticatedFollowUpActionsCreateRoute,
  AuthenticatedHotHoldingAlertsAlertIdRoute:
    AuthenticatedHotHoldingAlertsAlertIdRoute,
  AuthenticatedIncidentsIncidentIdRoute: AuthenticatedIncidentsIncidentIdRoute,
  AuthenticatedLogsLogTypeIdRoute: AuthenticatedLogsLogTypeIdRoute,
  AuthenticatedOrganisationsSlugRoute:
    AuthenticatedOrganisationsSlugRouteWithChildren,
  AuthenticatedPeopleNewRoute: AuthenticatedPeopleNewRoute,
  AuthenticatedPlatformSettingsCategoriesRoute:
    AuthenticatedPlatformSettingsCategoriesRoute,
  AuthenticatedPlatformSettingsStreakRulesRoute:
    AuthenticatedPlatformSettingsStreakRulesRoute,
  AuthenticatedChecklistManagerIndexRoute:
    AuthenticatedChecklistManagerIndexRoute,
  AuthenticatedChecklistsIndexRoute: AuthenticatedChecklistsIndexRoute,
  AuthenticatedComplianceManagerIndexRoute:
    AuthenticatedComplianceManagerIndexRoute,
  AuthenticatedComplianceIndexRoute: AuthenticatedComplianceIndexRoute,
  AuthenticatedEmergencyLightChecksIndexRoute:
    AuthenticatedEmergencyLightChecksIndexRoute,
  AuthenticatedEventRecordsIndexRoute: AuthenticatedEventRecordsIndexRoute,
  AuthenticatedEvidenceHubIndexRoute: AuthenticatedEvidenceHubIndexRoute,
  AuthenticatedFireExtinguisherChecksIndexRoute:
    AuthenticatedFireExtinguisherChecksIndexRoute,
  AuthenticatedFollowUpActionsIndexRoute:
    AuthenticatedFollowUpActionsIndexRoute,
  AuthenticatedLogsIndexRoute: AuthenticatedLogsIndexRoute,
  AuthenticatedMonitoringIndexRoute: AuthenticatedMonitoringIndexRoute,
  AuthenticatedOrganisationsIndexRoute: AuthenticatedOrganisationsIndexRoute,
  AuthenticatedPeopleIndexRoute: AuthenticatedPeopleIndexRoute,
  AuthenticatedPlatformSettingsIndexRoute:
    AuthenticatedPlatformSettingsIndexRoute,
  AuthenticatedSettingsIndexRoute: AuthenticatedSettingsIndexRoute,
  AuthenticatedTaskManagerIndexRoute: AuthenticatedTaskManagerIndexRoute,
  AuthenticatedTemplatesIndexRoute: AuthenticatedTemplatesIndexRoute,
  AuthenticatedComplianceDefinitionIdEditRoute:
    AuthenticatedComplianceDefinitionIdEditRoute,
  AuthenticatedComplianceDefinitionDefinitionIdRoute:
    AuthenticatedComplianceDefinitionDefinitionIdRoute,
  AuthenticatedComplianceInstanceInstanceIdRoute:
    AuthenticatedComplianceInstanceInstanceIdRoute,
  AuthenticatedPeopleUserIdLoginHistoryRoute:
    AuthenticatedPeopleUserIdLoginHistoryRoute,
  AuthenticatedSettingsStaffNewRoute: AuthenticatedSettingsStaffNewRoute,
  AuthenticatedTemplatesTemplateIdScheduleRoute:
    AuthenticatedTemplatesTemplateIdScheduleRoute,
  AuthenticatedPeopleUserIdIndexRoute: AuthenticatedPeopleUserIdIndexRoute,
  AuthenticatedSettingsStaffIndexRoute: AuthenticatedSettingsStaffIndexRoute,
  AuthenticatedSettingsStaffIdEditRoute: AuthenticatedSettingsStaffIdEditRoute,
  AuthenticatedSettingsStaffIdLoginAttemptsRoute:
    AuthenticatedSettingsStaffIdLoginAttemptsRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthRoute: AuthRouteWithChildren,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  AcceptInvitationRoute: AcceptInvitationRoute,
  InstallRoute: InstallRoute,
  NoAccessRoute: NoAccessRoute,
  PrintTestRoute: PrintTestRoute,
  SyncStatusRoute: SyncStatusRoute,
  Char126offlineRoute: Char126offlineRoute,
  PrintEventRecordsEventRecordIdRoute: PrintEventRecordsEventRecordIdRoute,
  PrintIncidentsIncidentIdRoute: PrintIncidentsIncidentIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
